var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 48216246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3H6C5.20462 3.00088 4.44207 3.31724 3.87965 3.87965C3.31724 4.44207 3.00088 5.20462 3 6V16C3.00088 16.7954 3.31724 17.5579 3.87965 18.1203C4.44207 18.6828 5.20462 18.9991 6 19H16C16.7954 18.9991 17.5579 18.6828 18.1203 18.1203C18.6828 17.5579 18.9991 16.7954 19 16V6C18.9991 5.20462 18.6828 4.44207 18.1203 3.87965C17.5579 3.31724 16.7954 3.00088 16 3ZM6 5H16C16.2652 5 16.5196 5.10536 16.7071 5.29289C16.8946 5.48043 17 5.73478 17 6V16C17.0002 16.1313 16.9743 16.2614 16.924 16.3827C16.8737 16.504 16.7998 16.6141 16.7067 16.7067L10.8853 10.8853C10.3853 10.3854 9.7071 10.1046 9 10.1046C8.2929 10.1046 7.61474 10.3854 7.11467 10.8853L5 13V6C5 5.73478 5.10536 5.48043 5.29289 5.29289C5.48043 5.10536 5.73478 5 6 5Z",
    fill: "#1B1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 9.66646C14.2537 9.66646 14.9999 8.92027 14.9999 7.99979C14.9999 7.07932 14.2537 6.33312 13.3332 6.33312C12.4128 6.33312 11.6666 7.07932 11.6666 7.99979C11.6666 8.92027 12.4128 9.66646 13.3332 9.66646Z",
    fill: "#1B1C1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductImageUpload);
export default __webpack_public_path__ + "static/media/icon_product_image_upload.14c8483b34c70f319b0584cbf5f78e0b.svg";
export { ForwardRef as ReactComponent };